import { getAxiosInstance } from "../ApiConfig";

async function FetchAllSalesOrder(page,limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllSalesOrderByReportingRoleUsers${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllSalesOrderPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllSalesOrderByReportingRoleUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllSalesOrderSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllSalesOrderByReportingRoleUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCompanySalesOrder() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSalesOrderByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchSalesOrderDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneBySalesOrder/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchSalesOrderByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllSalesOrderByDealId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteSalesOrder(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteSalesOrder/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createSalesOrder(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createSalesOrder`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateSalesOrder(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateSalesOrder/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createSalesOrder,
    updateSalesOrder,
    FetchAllSalesOrder,
    getCompanySalesOrder,
    FetchSalesOrderDetails,
    FetchSalesOrderByDeal,
    deleteSalesOrder,
    AllSalesOrderPaginationSearch,
    AllSalesOrderSearch,
}